// types
import { i18nDispatcherWeatherWidget } from 'models/i18n';

// ==============================|| I18N EN WEATHER WIDGET ||============================== //

const skDispatcherWeatherWidget: i18nDispatcherWeatherWidget = {
  titleCurrentWeather: 'Aktuálne počasie',
  titlePredictionWeather: 'Predpoveď počasia',
  airTemperature: 'Predikovaná teplota',
  measuredAirTemperature: 'Nameraná teplota',
  extendedWeatherForecast: 'Rozšírená predpoveď',
  weather: 'Počasie',
  period: 'perióda',
  maxMinTooltip: 'Najvyššia a najnižšia denná teplota',
  weatherForecast: {
    title: 'predpoveď',
    columns: {
      period: 'Obchodná perióda',
      airTemperature: 'Teplota',
      windSpeed10m: 'Vietor(10m)',
      windSpeed100m: 'Vietor(100m)',
      windDirection10m: 'Smer vetra (10m)',
      windDirection100m: 'Smer vetra (100m)',
      globalHorizontalIrradiance: 'Globálne horizontálne žiarenie GHI',
      globalHorizontalIrradiance10: 'GHI10',
      globalHorizontalIrradiance90: 'GHI90',
      diffuseHorizontalIrradiance: 'Difúzne horizontálne žiarenie DHI',
      diffuseHorizontalIrradiance10: 'DHI10',
      diffuseHorizontalIrradiance90: 'DHI90',
      directNormalIrradiance: 'Priame normálové žiarenie DNI',
      globalTiltedIrradiance: 'Globálne žiarenie na naklonenú plochu GTI',
      globalTiltedIrradiance10: 'GTI10',
      globalTiltedIrradiance90: 'GTI90',
      cloudOpacity: 'Oblačnosť'
    }
  },
  weatherMeasurementHistory: {
    title: 'história meraní',
    columns: {
      period: 'Perióda',
      airTemperature: 'Teplota',
      windSpeed: 'Vietor',
      windDirection: 'Smer vetra',
      globalHorizontalIrradiance: 'Globálne horizontálne žiarenie GHI',
      atmosphericPressure: 'Atmosferický tlak',
      relativeHumidity: 'Relatívna vlhkosť',
      dewPointTemperature: 'Rosný bod',
      rainfallRate: 'Zrážky',
      waterSnowEquivalent: 'Ekvivalent vody v hĺbke snehu'
    }
  }
};

export default skDispatcherWeatherWidget;
